import { Observable } from 'rxjs';

/**
 * Modulos que publican sus propios parametros de sistema.
 *
 * Un modulo que no aparezca aqui no tiene parametros propios y hereda los de
 * contabilidad, que es el modulo por defecto de la aplicacion.
 */
export type ModuloParametros = 'accounting' | 'treasury' | 'invoicing';

/** Modulo del que se leen los parametros cuando la pantalla no declara ninguno. */
export const MODULO_PARAMETROS_POR_DEFECTO: ModuloParametros = 'accounting';

/**
 * Lo unico que la barra superior necesita de los parametros de un modulo.
 *
 * Cada libreria implementa este contrato con SU servicio de parametros —el que
 * ya sabe a que microservicio preguntar— y lo registra en
 * `SystemSyncTopbarDateService` cuando arranca. Asi la barra no conoce
 * URLs de ningun modulo: solo pide la fecha a quien corresponda.
 */
export interface ParametrosSistemaPort {
  /** Fecha de operacion del modulo, en ISO (yyyy-MM-dd). */
  getSystemDate(): Observable<{ fechaSistema: string | null }>;
}

/**
 * Clave con la que una ruta declara de que modulo son sus parametros.
 *
 * Se pone en el `data` de la ruta raiz de cada libreria, junto a `breadcrumb` y
 * los demas, y las rutas hijas lo heredan. Una pantalla solo necesita
 * declararlo si sus parametros NO son los de su libreria.
 *
 * @example
 * data: { [DATA_MODULO_PARAMETROS]: 'treasury' }
 */
export const DATA_MODULO_PARAMETROS = 'parametrosModulo';
